import { useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { Button, Form, Modal, InputGroup } from 'react-bootstrap';
import ReCAPTCHA from 'react-google-recaptcha';
import { FiUser } from 'react-icons/fi';

import styles from './EsqueciSenha.module.css';
import forgotPassword from '../../api/forgotPassword';
import { encrypt } from '../../helpers/cryptography';
import logoFesaude2 from '../../assets/img/fesaude-logo2.png';

const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

const EsqueciSenha = () => {
  const history = useHistory();

  const [email, setEmail] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const captchaRef = useRef(null);
  const [recaptchaToken, setRecaptchaToken] = useState(null);
  const handleRecaptcha = () => setRecaptchaToken(captchaRef.current.getValue());

  const loading = false;

  const handleModalClose = () => setShowModal(false);

  const handleChange = e => {
    setEmail(e.target.value);
  };

  const handleSubmit = e => {
    e.preventDefault();

    try {
      const getData = async () => {
        const data = await forgotPassword({
          email: encrypt(email),
          recaptchaToken
        });
    
        if (data?.error) {
          setErrorMessage(data?.error);
          setShowModal(true);
        } else {
          history.push('/senha-ok');
        }
      };

      getData();
    } catch (error) {
      console.log(error);
    } finally {
      captchaRef?.current?.reset();
      setRecaptchaToken(null);

      return () => null;
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.form_container}>
        <div>
          <img src={logoFesaude2} alt="Logo FeSaúde" />
        </div>
        <h2 className={styles.title}>Redefinição de senha</h2>
        <Form 
          className={styles.form}
          as='form'
          onSubmit={handleSubmit} 
          noValidate
        >
          <Form.Group as='div' className={styles.form_group}>
          <Form.Label>*E-mail</Form.Label>
            <InputGroup>
              <InputGroup.Text className="border border-secondary">
              <FiUser />
              </InputGroup.Text>
              <Form.Control 
                type="email"
                required
                name="email"
                onChange={handleChange}
                value={email}
              />
            </InputGroup>
          </Form.Group>
          
          <div className={styles.captcha_container}>
            <ReCAPTCHA
              sitekey={RECAPTCHA_SITE_KEY}
              ref={captchaRef}
              onChange={handleRecaptcha}
              onExpired={() => setRecaptchaToken(null)}
            />
          </div>
            {!loading ? (
              <Button
                variant="flat"
                className={styles.btn}
                type="submit"
                disabled={!recaptchaToken ? true : false}
              >
                Entrar
              </Button>
            ) : (
              <Button 
               variant="flat" 
               className={styles.btn}
               disabled
              >
                Entrando...
              </Button>
            )}
        </Form>
        <Modal show={showModal} onHide={handleModalClose}>
          <Modal.Header closeButton>
            <Modal.Title>Erro</Modal.Title>
          </Modal.Header>
          <Modal.Body>{errorMessage}</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleModalClose}>
              Fechar
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
};

export default EsqueciSenha;
